import { render, staticRenderFns } from "./contact_type.vue?vue&type=template&id=b36c7414&scoped=true&"
import script from "./contact_type.vue?vue&type=script&lang=js&"
export * from "./contact_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c7414",
  null
  
)

export default component.exports